import { Typography, TypographyProps } from '@mui/material';

const StatisticText = ({ children, ...props }: { children: React.ReactNode } & TypographyProps) => (
  <Typography fontSize={26} fontWeight={700} lineHeight="32px" {...props}>
    {children}
  </Typography>
);

export default StatisticText;
